export default "__VITE_ASSET__BLAlYjTR__"